/**
 * Two ways this package refuses to guess.
 *
 * A broken rule set is a programming error, so it fails when the rule set is defined, with every problem listed, rather than producing plausible-looking scores. A malformed input — an unknown enum value, an impossible range, a MIXED face without its two components — is refused the same way, because a silent fallback would turn a bug into advice.
 */

/** The rule set is incomplete or inconsistent. Every problem found is listed, not just the first. */
export class FrameRuleSetError extends Error {
  readonly problems: readonly string[];

  constructor(problems: readonly string[]) {
    super(`Invalid frame recommendation rule set:\n- ${problems.join('\n- ')}`);
    this.name = 'FrameRuleSetError';
    this.problems = problems;
  }
}

/** An input the rules cannot evaluate honestly. */
export class FrameInputError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FrameInputError';
  }
}
